class a {
  constructor(t, e) {
    this.persistentStorageState = t, this.reactiveState = e;
  }
  switchContext(t) {
    this.persistentStorageState.switchContext(t), this.reactiveState.switchContext(t), this.reactiveState.set(this.persistentStorageState.get());
  }
  get() {
    return this.reactiveState.get();
  }
  set(t) {
    this.persistentStorageState.set(t), this.reactiveState.set(t);
  }
  reset() {
    this.persistentStorageState.reset(), this.reactiveState.reset();
  }
}
export {
  a as StateFacade
};
//# sourceMappingURL=index4.js.map
